// Native
import { useState } from "react"
import Moment from "react-moment"
import { Box, Button, DialogBody, Flex, Image, SimpleGrid, Text } from "@chakra-ui/react"

// Custom
import { Parts, UI } from "components"
import { Styles } from "config"
import useAnticipations from "hooks/useAnticipations"

export default function List(props){

    const anticipations = useAnticipations()
    const [ anticipation, setAnticipation ] = useState(false)

    return(
    <>
    <Parts.Dialog.Anticipations.View open={!!anticipation} data={anticipation} onClose={() => setAnticipation(false)} />
    <UI.Dialog title="Histórico de antecipações" size="xl" {...props}>
        <DialogBody>

            <SimpleGrid columns={{ base: 1, sm: 1, md: 3, lg: 3 }} gap={2}>

                { anticipations.data?.map(item => <Anticipation key={item.id} data={item} onClick={() => setAnticipation(item)} />)  }
                
            </SimpleGrid>

            <Button w="100%" mt={4} variant="subtle" onClick={props.onClose}><UI.Icon name="prev" /> Voltar</Button>
        </DialogBody>
    </UI.Dialog>
    </>
    )
}

const Anticipation = ({ data, ...props }) => {

    const careerStyle = Styles.pin(data?.career?.id)

    return(
    <UI.Pressable {...props}>
        <Flex 
            direction={{ base: 'row', sm: 'column', md: 'column', lg: 'column' }} 
            alignItems="center" 
            justifyContent={{ base: 'flex-start', sm: 'flex-start', md: 'center', lg: 'center' }} 
            textAlign={{ base: 'left', sm: 'left', md: 'center', lg: 'center' }} 
            p={4} 
            borderColor="border.subtle" 
            borderWidth={1} 
            borderRadius={4} 
            backgroundColor={careerStyle.colorPalette + '.subtle'} 
            gap={4}
        >
            <Image src={careerStyle.image_url} h="60px" mb={2} />
            <Box>
                <Text fontWeight="bold" color={careerStyle.colorPalette + '.fg'}>{data?.career?.title}</Text>
                <Text fontSize="xs" color="fg.muted"><Moment format="LLL" children={data.created_at} /></Text>
            </Box>
        </Flex>
    </UI.Pressable>
    )
}